var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPutAway(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1768647713034,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 29587,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128,
    height: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M880.3 112.44h-736a32 32 0 0 0-32 32v760a8 8 0 0 0 8 8h40a8 8 0 0 0 8-8v-112h688v112a8 8 0 0 0 8 8h40a8 8 0 0 0 8-8v-760a32 32 0 0 0-32-32z m-712 624v-164h248a8 8 0 0 0 8-8v-40a8 8 0 0 0-8-8h-248v-148h192a8 8 0 0 0 8-8v-40a8 8 0 0 0-8-8h-192v-144h688v568z",
    "p-id": 29588,
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M797.22 399.31l-147.8-115.48a16 16 0 0 0-19.7 0L481.91 399.31a8 8 0 0 0-1.38 11.23l29.55 37.82a8 8 0 0 0 11.23 1.38l85.52-66.82v257.52a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8V381.78l87 68a8 8 0 0 0 11.17-1.42l29.55-37.82a8 8 0 0 0-1.33-11.23z",
    "p-id": 29589,
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPutAway);
export default __webpack_public_path__ + "static/media/putAway.b18c181ef51cfe7c36ab6f48aefa1560.svg";
export { ForwardRef as ReactComponent };